// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 单位标签，紧跟 input-number 右侧 */\n.ipt-unit[data-v-156c8034] {\n  margin-left: 8px;\n  font-size: 12px;\n  color: #606266;\n}\n\n/* 换算提示，灰色小字 */\n.ipt-convert[data-v-156c8034] {\n  margin-left: 10px;\n  font-size: 12px;\n  color: #909399;\n}", ""]);
// Exports
module.exports = exports;
